export const Facet = {
	profession_id: 'profession_id',
	education_type_id: 'education_type_id',
	license_type_id: 'license_type_id',
	license_levels: 'license_levels',
	state_code: 'state_code',
	delivery_method_id: 'delivery_method_id',
	credit_type: 'credit_type',
	tags: 'tags',
	authors: 'authors',
	instructors: 'instructors',
	primary_hours: 'primary_hours',
	secondary_hours: 'secondary_hours',
	start_time: 'start_time',
	location: 'location',
	price: 'price',
	rating: 'rating',
	search_phrase: 'search_phrase',
	search_phrase_item_ids: 'search_phrase_item_ids',
	is_partnership_group_item_required: 'is_partnership_group_item_required'
}

export const Event = {
	FILTER_CHANGED: 'FILTER_CHANGED',
	ITEMS_CHANGED: 'ITEMS_CHANGED',
	REQUEST_REINDEX: 'REQUEST_REINDEX',
	UPDATE_TIMEZONES: 'UPDATE_TIMEZONES',
	LIST_UPDATE: 'LIST_UPDATE'
}

const RANGE_FACETS = [
	Facet.primary_hours,
	Facet.secondary_hours,
	Facet.price,
	Facet.rating,
	Facet.start_time,
];

const SINGULAR_FACETS = [
	Facet.profession_id,
	Facet.state_code
];

export const ENUMERABLE_FACETS = [
	Facet.profession_id,
	Facet.license_levels,
	Facet.education_type_id,
	Facet.license_type_id,
	Facet.state_code,
	Facet.delivery_method_id,
	Facet.credit_type,
	Facet.tags,
	Facet.authors,
	Facet.instructors,
	Facet.is_partnership_group_item_required
];

/**
 * @param {string} facetName
 * @returns {boolean}
 */
export function isRangeFacet( facetName ){
	return RANGE_FACETS.includes( facetName );
}

/**
 * @param {string} facetName
 * @returns {boolean}
 */
export function isSingularFacet( facetName ){
	return SINGULAR_FACETS.includes( facetName );
}

/**
 * @param {string} facetName
 * @returns {boolean}
 */
export function isEnumerableFacet( facetName ){
	return ENUMERABLE_FACETS.includes( facetName ) || isTagFacet( facetName );
}

/**
 * @param {string} facetName
 * @returns {boolean}
 */
export function isTagFacet( facetName ){
	return facetName !== facetName.replace( Facet.tags + '::', '' );
}

/**
 * @param {string} facetName
 * @returns {string}
 */
export function getTagTypeName( facetName ){
	const tagTypeName = facetName.replace( Facet.tags + '::', '' );
	return (facetName !== tagTypeName) ? tagTypeName: null;
}

function deg2rad( n ) {
	return n * ( Math.PI / 180 );
}

function distanceFromLocation( zipLat, zipLong, facilityLat, facilityLong ) {
	var R = 3959,
		point = { latitude: zipLat, longitude: zipLong },
		interest = { latitude: facilityLat, longitude: facilityLong },
		dLat = deg2rad( interest.latitude - point.latitude ),
		dLon = deg2rad( interest.longitude - point.longitude ),
		a = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) + Math.cos( deg2rad( point.latitude ) ) * Math.cos( deg2rad( interest.latitude ) ) * Math.sin( dLon / 2 ) * Math.sin( dLon / 2 ),
		c = 2 * Math.asin( Math.sqrt( a ) );

	return R * c;
}

/**
 * @param {object} item
 * @param {object} filter
 * @returns {boolean}
 */
export function isMatchingLocation( item, filter ){
	if ( typeof item['first_variant']['facilities'] === 'undefined' ) {
		return false;
	}
	const facilities = Object.entries( item['first_variant']['facilities'] );
	if ( !facilities.length ) {
		return false;
	}
	return facilities.some( ([fid, fac]) => {
		if ( fac.lat && fac.lng && filter.lat && filter.lng ) {
			return distanceFromLocation( filter.lat, filter.lng, fac.lat, fac.lng ) <= filter.distance;
		}
		return false;
	});
}
